import React from 'react';
import styled, { keyframes } from 'styled-components';
import SVG from 'react-inlinesvg';
import { buttonReset } from '../styled/buttons';
import { inputStyles } from '../styled/inputs';
import iconSrc from '../../utils/iconSrc';
import { linkStyles } from '../styled/links';
import Button from '../button';

export const ShopListWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const GeoLocation = styled.p`
  margin: 5px 0px;
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const LinkButton = styled.button`
  ${buttonReset};
  ${linkStyles};
`;

export const Distance = styled.p`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.standardText};
  margin: 14px 0 0;
`;

export const IntroWrapper = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.large};
`;

export const SearchForm = styled.form`
  width: 100%;
`;
export const SearchFinderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing.standard};
  padding-top: 0;
  background: ${({ theme }) => theme.palette.lightBackground};
  margin-bottom: ${({ theme }) => theme.spacing.large};
`;

export const SearchShopTitle = styled.h2`
  font-size: ${({ theme }) => theme.fontsize.h3};
`;

export const SearchWrapper = styled.div`
  display: flex;
  max-width: 100%;
`;

export const ShopItemWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
`;

export const ShopBody = styled.div`
  padding-left: 10px;
  width: 100%;
  ${({ $last, theme }) =>
    !$last
      ? `
      border-bottom: 1px solid ${theme.palette.border};
      padding-bottom: 30px;`
      : null}
`;

export const ShopHeading = styled.h3`
  margin-top: 0;
  margin-bottom: 30px;
`;

export const ShopContent = styled.p`
  margin-bottom: 5px;
`;

export const ShopItemIcon = () => (
  <SVG src={iconSrc('map-marker')} width="25px" height="25px" fill="inherit" />
);
export const SearchInput = styled.input`
  ${inputStyles}
  margin-right: 4px;
  max-width: 164px;
`;
export const SearchButton = styled(Button)`
  margin-right: 4px;
`;

export const StatusMessage = styled.div`
  display: block;
  margin: ${({ theme }) => theme.spacing.tiny} 0;
  color: ${({ theme }) => theme.palette.brand};

  p {
    margin: 0;
  }
`;

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -124;
  }
`;

export const SpinnerSVG = styled(SVG)`
  width: 25px;
  height: 25px;
  animation: ${rotate} 2s linear infinite;

  .path {
    stroke: ${({ theme }) => theme.palette.brand};
    stroke-linecap: round;
    animation: ${dash} 1.5s ease-in-out infinite;
  }
`;
